export default "__VITE_ASSET__CgY1eYOF__"